import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import AppRouter from './app-router'
import ErrorBoundary from './components/errorBoundary/error-boundary'
import EdgeWarning from './edge-warning'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <EdgeWarning >
        <AppRouter />
      </EdgeWarning>
    </ErrorBoundary>
  </React.StrictMode>,
)
